<template>
  <div class="map-landing" :class="{ 'map-active': isMapActive }">
    <div class="main-content-container">
      <div class="main-content">
        <div class="main-content-header">
          <RouterLink to="/">
            <LogoType />
          </RouterLink>
          <button type="button" class="explore-btn" @click="isMapActive = true">
            <slot name="map-icon">
              <img class="explore-icon" src="@/assets/explore-icon.png" />
              <span>explore map</span>
            </slot>
          </button>
        </div>
        <slot name="content" :toggleMap="toggleMap" />
      </div>
    </div>
    <div class="map-container">
      <button
        type="button"
        class="back-btn"
        @click="isMapActive = false"
        title="Back"
      >
        <ArrowLeft />
      </button>
      <slot name="map" />
    </div>
  </div>
</template>

<script>
import ArrowLeft from '@/assets/arrow-left-large.svg';
import LogoType from '@/components/logo-type';

export default {
  components: {
    ArrowLeft,
    LogoType,
  },
  data() {
    return {
      isMapActive: false,
    };
  },
  methods: {
    toggleMap() {
      this.isMapActive = !this.isMapActive;
    },
  },
};
</script>

<style lang="scss" scoped>
$breakpoint: 768px;

.map-landing {
  display: flex;
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  transform: translateX(0);
  transition: transform 0.2s ease-in-out;
  width: 200vw;

  @media screen and (min-width: $breakpoint) {
    right: 0;
    width: 100%;
  }

  &.map-active {
    transform: translateX(-100vw);

    @media screen and (min-width: $breakpoint) {
      transform: translateX(0);
    }
  }
}

.main-content-container {
  background: var(--light-blue);
  color: var(--white);
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media screen and (min-width: $breakpoint) {
    max-width: 450px;
  }
}

.main-content-container,
.map-container {
  width: 50%;
}

.main-content,
.map-container {
  display: flex;
  flex-direction: column;
  padding: var(--page-padding);
}

.main-content {
  flex: 1;
}

.main-content-header {
  align-items: flex-start;
  justify-content: space-between;
  display: flex;
  flex-shrink: 0;
  margin-bottom: 24px;
}

.explore-btn {
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 12px;

  @media screen and (min-width: $breakpoint) {
    display: none;
  }
}

.explore-icon {
  height: 40px;
  width: 45px;
}

.map-container {
  align-items: center;
  overflow: hidden;
  position: relative;

  @media screen and (min-width: $breakpoint) {
    flex: 1;
    width: auto;
  }
}

.back-btn {
  left: var(--page-padding);
  position: absolute;
  top: var(--page-padding);
  z-index: 2;

  @media screen and (min-width: $breakpoint) {
    display: none;
  }
}
</style>
